const getters = {
    appTheme: state => state.appTheme,
    userInfo: state => state.userInfo,
    systemInfo: state => state.systemInfo,

    documentSize: state => state.documentSize,

    trainTypeMenu: state => state.trainTypeMenu,
    trainSpecialMenu: state => state.trainSpecialMenu,
    trainModeMenu: state => state.trainModeMenu,
    groupMenu: state => state.groupMenu,
    examFormMenu: state => state.examFormMenu,
    forLevelMenu: state => state.forLevelMenu,
    positionMenu: state => state.positionMenu,
    userTypeMenu: state => state.userTypeMenu,
    orgTree: state => state.orgTree,
    courseTypeMenu: state => state.courseTypeMenu,
    paperTypeMenu: state => state.paperTypeMenu,
    difficultyMenu: state => state.difficultyMenu,
    topicTypeMenu: state => state.topicTypeMenu,
    paperMethodMenu: state => state.paperMethodMenu,
    knowledgeMenu: state => state.knowledgeMenu,
    systemKnowledgeMenu: state => state.systemKnowledgeMenu,
    markKnowledgeMenu: state => state.markKnowledgeMenu,
    examStatusMenu: state => state.examStatusMenu,
    certTypesMenu: state => state.certTypesMenu,
    preJobMenu: state => state.preJobMenu,
    viewCountMenu: state => state.viewCountMenu,
    imageOriginMenu: state => state.imageOriginMenu,
    ledgerOriginMenu: state => state.ledgerOriginMenu,
    uploadTop: state => state.uploadTop,
    projectTypeMenu: state => state.projectTypeMenu,
    knowledgeTypeMenu: state => state.knowledgeTypeMenu,
    creditTypeMenu: state => state.creditTypeMenu,
    rankTypeMenu: state => state.rankTypeMenu,
    fiscanProductMenu: state => state.fiscanProductMenu,

    userTrainSetting: state => state.userTrainSetting,

    wsBrowser: state => state.wsBrowser,
    wsTrainee: state => state.wsTrainee,
};

export default getters
